export const WIZARD_STEPS = [
  { key: 'contest', label: 'Contest' },
  { key: 'locality', label: 'Locality' },
  { key: 'goal', label: 'Goal' },
  { key: 'audience', label: 'Audience' },
  { key: 'review', label: 'Review' },
] as const

export type StepKey = (typeof WIZARD_STEPS)[number]['key']
